module.exports = __webpack_public_path__ + "static/media/ca-dca.dca8a751.png";